import { jsx } from 'panel';
import { SelectEl } from 'common/components/select';
import { SvgIconEl } from 'common/components/svg-icon';
export function template() {
  return jsx(SelectEl, {
    attrs: {
      elref: "searchDropdownMenu",
      icon: "brand-search",
      'icon-only': true,
      'menu-height': 500,
      'menu-width': null,
      open: this.attr("open"),
      'preserve-search-on-close': true,
      'clear-search-on-change': true,
      'hide-input-focus-styling': true,
      'search-placeholder': "Search Dashboards & Reports",
      'search-threshold': 0,
      'show-clear': true
    },
    sel: '.global-search-dropdown',
    props: {
      sectionsFromInputFn: this.helpers.searchSectionsFromInput,
      sections: this.helpers.getSearchSections()
    },
    on: {
      change: this.helpers.handleSearchSelection,
      focusItem: this.helpers.handleFocusItem,
      menuChange: this.helpers.handleSelectMenuChanged,
      searchFilterChange: this.helpers.handleSearchFilterChange
    }
  }, jsx("div", {
    sel: '.mp-chrome-categories-trigger-container-icon',
    attrs: {
      slot: "trigger"
    },
    class: {
      selected: this.attr("open")
    }
  }, jsx(SvgIconEl, {
    attrs: {
      icon: "search"
    }
  })));
}